 const StackJamColors = {
    "red": "#9D1107",
    "maroon": "#3A0603",
    "yellow": "#f6f930",
    "black": "#000000",
    "white": "#FFFFFF"
}

export default StackJamColors